// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fulfillment-collection-view__fulfillments-container:not(:last-child)>.fulfillment-view__wrapper>.fulfillment-view{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
